import { html, TemplateResult } from 'lit'

export function Divider(): TemplateResult {
  return html`<hr role="separator" />`
}
